module.exports = __webpack_public_path__ + "static/media/zeya_cry_02.cdc121b1.gif";